import { Card } from '@/components/ui/Card';
import { Notice } from '@/components/ui/Notice';
import { ScreenHeader } from '@/components/ui/ScreenHeader';
import { useI18n } from '@/i18n/context';

/** Plain-language summary of what is (and is not) stored. */
export function PrivacyFacts() {
  const { t } = useI18n();
  return (
    <div className="flex flex-col gap-4">
      <Card className="flex flex-col gap-3">
        <p className="font-bold">{t('privacy.intro')}</p>
        <p>{t('privacy.stored')}</p>
        <p>{t('privacy.notStored')}</p>
        <p>{t('privacy.noTrackers')}</p>
      </Card>
      <Notice tone="warning" icon="⚠️" title={t('privacy.localWarningTitle')}>
        {t('privacy.localWarning')}
      </Notice>
    </div>
  );
}

export function PrivacyScreen() {
  const { t } = useI18n();
  return (
    <div className="flex flex-col gap-6">
      <ScreenHeader title={t('privacy.title')} back={true} />
      <PrivacyFacts />
      <p className="text-ink-muted">{t('privacy.backupHowTo')}</p>
    </div>
  );
}
